import { render } from "./MainServices.vue?vue&type=template&id=2a4cdb11&scoped=true"
import script from "./MainServices.vue?vue&type=script&lang=js"
export * from "./MainServices.vue?vue&type=script&lang=js"

import "./MainServices.vue?vue&type=style&index=0&id=2a4cdb11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4cdb11"]])

export default __exports__